/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchangewhen3Inputs */

const en_aiflowchangewhen3 = /** @type {(inputs: Aiflowchangewhen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the date`)
};

const de_aiflowchangewhen3 = /** @type {(inputs: Aiflowchangewhen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin ändern`)
};

/**
* | output |
* | --- |
* | "Change the date" |
*
* @param {Aiflowchangewhen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchangewhen3 = /** @type {((inputs?: Aiflowchangewhen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchangewhen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchangewhen3(inputs)
	return de_aiflowchangewhen3(inputs)
});
export { aiflowchangewhen3 as "aiFlowChangeWhen" }